import actions from './actions'
import mutations from './mutations'

const state = {
  currentCampaign: null
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
